import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateShipmentComponent } from './components/create-shipment/create-shipment.component';
import { EditShipmentComponent } from './components/edit-shipment/edit-shipment.component';

const routes: Routes = [
  { path: '', component: CreateShipmentComponent },
  { path: 'edit', component: EditShipmentComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateShipmentRoutingModule { }
